import script from "./ShowCredit.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowCredit.vue?vue&type=script&setup=true&lang=js"

import "./ShowCredit.vue?vue&type=style&index=0&id=74c8e70c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74c8e70c"]])

export default __exports__